<template>
  <div>

      <div class="person-hover">

          <!-- Loading User Information Popup -->
          <div v-if="isLoading">
              <p class="loading-text">Loading...</p>
          </div>

          <!-- When the popup is ready -->
          <div v-else-if="currentUser" class="loaded-content">

              <a :href="`/${currentUser.username}`" class="person-hover__image">
                  <img :src="currentUser.md_avatar" />
              </a>

              <h3>
                  <a :href="`/${currentUser.username}`" v-text="currentUser.full_name"></a>
              </h3>

              <p v-text="currentUser.profile.biography"></p>

              <div class="follow-links">

                  <!-- Following Button -->
                  <span v-if="followingCount" class="following-trigger">
                      {{ followingCount }}
                      Following
                  </span>

                  <!-- Followers Button -->
                  <span v-if="followersCount" class="followers-trigger cursor-default">
                      {{ followersCount }}
                      Followers
                  </span>
              </div>

              <button v-if="isFollowing"  class="button already-following" :disabled="updatingFollow" @click="toggleFollow()">
                  <small v-if="!updatingFollow">Unfollow</small>
                  <small v-else>Unfollowing...</small>
                  <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
              </button>

              <button v-else class="button" :disabled="updatingFollow" @click="toggleFollow()">
                  <small v-if="!updatingFollow">Follow</small>
                  <small v-else>Following...</small>
                  <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
              </button>
      </div>
    </div>
  </div>
</template>

<script>

import Helpers from '@/mixins/Helpers';
import Verified from '@/components/Verified';

  export default {

      mixins: [Helpers],

      components: {
          Verified,
      },

      data() {
          return {
              isLoading: false,
              userExistsInCache: false,
              users: [],
              currentUser: null,
              isFollowing: false,
              followingCount: null,
              followersCount: null,
              updatingFollow: false,
          }
      },

      mounted() {
          if (!this.isMobile) {
              this.registerListeners()
          }
      },

      methods: {

          findUser(username) {
              // this.username = username
              if (this.isLoading) {
                  return
              }
              this.isLoading = true
              this.userExistsInCache = false
              let user = _.find(this.users, u => {
                  return u.username == username
              })
              if (user) {
                  this.currentUser = user
                  this.isLoading = false
                  return false;
              }
              this.getUserFromBackend(username)
          },

          getUserFromBackend(username) {

              // $('.person-hover').outerHeight(60)

              axios.get(`/user/${username}/follow-information`)
                  .then(response => {
                      // User
                      this.currentUser = response.data.user
                      this.isFollowing = response.data.is_following
                      // Counts
                      this.followingCount = response.data.following_count;
                      this.followersCount = response.data.followers_count;

                      this.users.push(this.currentUser)
                      this.isLoading = false

                      this.showPopup()

                  })
                  .catch(errors => console.log(errors))
          },

          showPopup() {
              $('.person-hover').addClass('transition')
              setTimeout(() => {
                  $('.person-hover').outerHeight(
                      $('.person-hover')[0].scrollHeight + 24
                  )
                  setTimeout(() => {
                      $('.person-hover').removeClass('transition')
                      $('.person-hover').css('height', 'auto')
                  }, 300)
              }, 100)
          },

          toggleFollow() {
              this.updatingFollow = true
              axios.patch(`/user/${this.currentUser.username}/follow`)
                  .then(response => {
                      // User
                      // this.currentUser = response.data.user
                      this.isFollowing = response.data.is_following
                      // Counts
                      this.followingCount = response.data.following_count;
                      this.followersCount = response.data.followers_count;

                      this.updatingFollow = false

                      // const i = this.users.findIndex(u => u.id === this.currentUser.id)
                      // this.users[i] = response.data.user

                  })
                  .catch(errors => console.log(errors))
          },

          registerListeners() {
              let self = this;
              $(document).on('mouseenter', '.person-hover-trigger', function (event) {

                  let username = event.target.dataset.user
                  self.findUser(username, event)

                  var x = event.clientX
                  var y = event.clientY

                  if (!$(this).hasClass('active-hover')) {

                      $(this).addClass('active-hover')

                      $('.active-hover')
                          .not(this)
                          .removeClass('active-hover')

                      $('.fixed-person-hover .person-hover')
                          .css({top: y + 'px', left: x + 'px'})
                          .addClass('active')
                  }
              })

              $(document).on('mouseleave', '.person-hover-trigger', function (e) {
                  setTimeout(() => {
                      if (!$('.person-hover-trigger.active-hover:hover').length && !$('.fixed-person-hover .person-hover:hover').length) {
                          $('.fixed-person-hover .person-hover').removeClass('active')
                          $('.person-hover-trigger.active-hover').removeClass('active-hover')
                      }
                  }, 150)
              })

              $(document).on('mouseleave', '.fixed-person-hover .person-hover', function (e) {
                  $('.fixed-person-hover .person-hover').removeClass('active')
                  $('.person-hover-trigger.active-hover').removeClass('active-hover')
              })

              $(window).on('scroll', function () {
                  $('.fixed-person-hover .person-hover').removeClass('active')
              })
          }
      },
  }
</script>
